<div *ngFor="let trafficLightTuple of trafficLights" class="traffic-light-group">
  <pcs-traffic-light
    *ngIf="hasValue(applicant(trafficLightTuple))"
    [disabled]="true"
    [extended]="extended"
    [agency]="applicant(trafficLightTuple).agency"
    [leading]="applicant(trafficLightTuple).leadingAgency"
    [progressStatus]="applicant(trafficLightTuple).progressStatus">
  </pcs-traffic-light>

  <pcs-traffic-light
    *ngIf="hasValue(im(trafficLightTuple))"
    [disabled]="true"
    [extended]="extended"
    [agency]="im(trafficLightTuple).agency"
    [leading]="im(trafficLightTuple).leadingAgency"
    [progressStatus]="im(trafficLightTuple).progressStatus">
  </pcs-traffic-light>

  <pcs-traffic-light
    *ngIf="hasValue(coss(trafficLightTuple))"
    [disabled]="true"
    [extended]="extended"
    [agency]="coss(trafficLightTuple).agency"
    [leading]="coss(trafficLightTuple).leadingAgency"
    [progressStatus]="coss(trafficLightTuple).progressStatus">
  </pcs-traffic-light>
</div>
